import axios from 'axios';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import { Competition } from '@repo/types';
import API from '../endpoints';

export const useCompetitionQuery = (id: string | undefined) => {
  return useQuery({ queryKey: ['competition', { id: id! }], queryFn: fetchCompetition, enabled: !!id });
};

const fetchCompetition: QueryFunction<Competition, [string, { id: string }]> = async ({ queryKey }) => {
  const [, { id }] = queryKey;
  const { data } = await axios.get<Competition>(`${API.endpoints.competitions}/${id}`);
  return data;
};
